export function disconnectTwitter(_csrf: string) {
  return fetch('/social/link/twitter/disconnect', {
    method: 'POST',
    credentials: 'same-origin',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ _csrf }),
  })
    .then(response => {
      if (response.ok) {
        return response;
      }
      throw new Error('Unable to disconnect twitter account');
    })
    .catch(err => {
      throw new Error(err);
    });
}
